import React, { useEffect, useState } from 'react';
import t from '~t';
import { openTab, hotkeys } from '~target';

import { Layout, Title, SubLabel } from '~ui';

export default function SettingsExtensionHotkeys() {
  const [all, setAll] = useState([]);

  useEffect(() => {
    let mounted = true;
    hotkeys.getAll().then((list) => {
      if (mounted) setAll(list);
    });
    return () => {
      mounted = false;
    };
  }, []);

  const renderHotkey = ({ description, shortcut, name }) => (
    <div key={name}>
      {shortcut || '-'}
      <SubLabel>{description || t.s('openBrowserExtension')}</SubLabel>
    </div>
  );

  if (!all.length) return null;

  return (
    <>
      <Title>{t.s('helpHotKey')}</Title>

      <Layout type='columns'>{all.map(renderHotkey)}</Layout>

      {hotkeys.link() ? (
        <SubLabel>
          <a
            href=''
            onClick={(e) => {
              e.preventDefault();
              openTab(hotkeys.link(), true);
            }}
          >
            {t.s('changeHotkeys')}
          </a>
        </SubLabel>
      ) : null}
    </>
  );
}
